import { render, staticRenderFns } from "./whitelist-manage.vue?vue&type=template&id=cb356830&"
import script from "./whitelist-manage.vue?vue&type=script&lang=js&"
export * from "./whitelist-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports